import generalUpload from "../_section/upload.class";

export class userBusinessAccountStatementUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'startDate',
            label: 'Start Date',
            type: 'date',
        },
        {
            name: 'endDate',
            label: 'End Date',
            type: 'date',
        },
        {
            name: 'iban',
            label: 'IBAN',
            type: 'text',
        }
    ]
}

export class adminBusinessAccountStatementUpload extends userBusinessAccountStatementUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.endDate) {
            this.setDateData({
                dated: this.values.endDate.local().startOf('day'),
                range:{
                    from:{
                        date: this.values.startDate?.local()?.startOf('day'),
                    },
                    to: {
                        date: this.values.endDate.local().startOf('day'),
                    }
                },
                expires: this.values.endDate.add(6, 'month'),
            })
        }
        if (!upload.examined){
            this.problems.push('Not Examined');
        }
    }
}
